import { axiosInstance as request } from '@/api/rest.service'

export const getSubjectCategories = () => request.get('/subject-categories')
export const createSubjectCategory = payload => request.post('/subject-categories', payload)
export const updateSubjectCategory = (id, payload) => request.put(`/subject-categories/${id}`, payload)
export const getDeleteConfirmation = id => request.get(`/subject-categories/${id}/delete-confirmation`)
export const deleteSubjectCategory = id => request.delete(`/subject-categories/${id}`)
